export enum SortOrder {
    ASC = 0,
    DESC = 1,
}

export enum FilterType {
    TextFilter = 1,
    MultipleSelectFilter = 2,
}

export class FilterSortViewParameter {
    filterActive: boolean;
    sortOrder: boolean;
    constructor() {
        this.filterActive = false;
        this.sortOrder = false;
    }
}

export class FilterOutputDto {
    filterValue: string;
    blankValues: boolean;
    sortOrder: number;
    filterPropertyNumber: number;
    sortPropertyNumber: number;
    constructor() {
        this.filterValue = '';
        this.blankValues = false;
        this.sortOrder = SortOrder.ASC;
    }
}

export class MultipleSelectFilterValue {
    filterValue: string;
    checked: boolean;
    constructor(_filterValue: string = '', _checked: boolean = true) {
        this.filterValue = _filterValue;
        this.checked = _checked;
    }
}

export class FilterPopupResult {
    filterValue: string;
    active: boolean;
    blankValues: boolean;
}

export interface FilterState {
    filterType: FilterType;
    filterColumn: string;
    filterOptions: FilterOption[] | null;
    isFilterApplied: boolean;
    searchtext: string | null;
}

export interface FilterOption {
    optionName: string;
    isSelected: boolean;
}

